import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
	selector: "bp-value-change",
	templateUrl: "./bp-value-change.component.html",
	styleUrls: ["./bp-value-change.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class BpValueChangeComponent {
	@Input() public value: number = 0;
	@Input() public showArrows: boolean = false;
	@Input() public isPortfolioValueHidden: boolean = false;
}
